<template>
  <page-main @back="() => (isShowLeave = true)">
    <template slot="nav">
      <div class="score-nav">
        <p>比赛信息</p>
      </div>
    </template>
    <template slot="main">
      <div class="page-main">
        <div class="step-box">
          <el-steps
            :active="activeStep"
            finish-status="success"
            process-status="wait"
            simple
          >
            <el-step title="比赛信息"></el-step>
            <el-step title="球探信息"></el-step>
            <el-step title="球员信息"></el-step>
            <el-step title="五环评分"></el-step>
            <el-step title="主观评价"></el-step>
          </el-steps>
        </div>
        <div class="scroll-area">
          <template>
            <vue-scroll>
              <div class="scroll-wrapper">
                <el-form
                  class="form-dom"
                  ref="completeFormDom"
                  :model="completeForm"
                  label-width="240px"
                >
                  <!-- 暂时不设置本页面表单验证 :rules="completeRules" -->
                  <!-- 选择比赛 -->
                  <el-form-item class="yioks-form-item" label="比赛列表">
                    <el-select
                      v-model="competionChosed"
                      @change="handleCompetionChanged"
                      clearable
                      :disabled="isEdit && competionChosed ? true : false"
                      class="yioks-input"
                      placeholder="请选择比赛"
                    >
                      <el-option
                        v-for="item in competionsList"
                        :key="item.key"
                        :label="item.key"
                        :value="item.content"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 比赛日期与开球时间 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="kickTime"
                    label="比赛日期与开球时间"
                  >
                    <el-date-picker
                      v-model="completeForm.kickTime"
                      disabled
                      :value-format="'timestamp'"
                      class="yioks-input"
                      type="datetime"
                      placeholder="比赛日期与开球时间"
                    ></el-date-picker>
                  </el-form-item>

                  <!-- 比赛名称与场次 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="competition"
                    label="比赛名称与场次/轮次"
                  >
                    <el-input
                      v-model="completeForm.competition"
                      disabled
                      class="yioks-input"
                      placeholder="比赛名称与场次/轮次"
                    ></el-input>
                  </el-form-item>

                  <!-- 比赛对阵 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="vs"
                    label="比赛对阵"
                  >
                    <el-input
                      v-model="completeForm.vs"
                      disabled
                      class="yioks-input"
                      placeholder="比赛对阵"
                    ></el-input>
                  </el-form-item>

                  <!-- 比赛城市与场地 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="location"
                    label="比赛城市与场地"
                  >
                    <el-input
                      v-model="completeForm.location"
                      disabled
                      class="yioks-input"
                      placeholder="比赛城市与场地"
                    ></el-input>
                  </el-form-item>

                  <!-- 天气情况 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="weather"
                    label="天气情况"
                  >
                    <el-input
                      v-model="completeForm.weather"
                      disabled
                      class="yioks-input"
                      placeholder="天气情况"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </vue-scroll>
          </template>
        </div>
        <div class="btn-box">
          <el-button
            type="primary"
            @click.native.prevent="handleClick('completeFormDom')"
            >下一步</el-button
          >
        </div>
        <yioks-tips
          :showTips="isShowLeave"
          tips="离开页面未提交数据将会丢失，确认离开？"
          @hideTips="handleLeave"
        ></yioks-tips>
      </div>
    </template>
  </page-main>
</template>

<script>
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { getCompetionList } from "@/api/scout";
import yioksStorage from '@/assets/js/yioksStorage';

export default {
  data() {
    return {
      isShowLeave: false,
      requiredItem,
      activeStep: 1,
      competionChosed: "", // 选择的比赛
      competionsList: [], // 比赛列表
      completeForm: {
        kickTime: "", // 比赛日期开球时间
        competition: "", // 比赛名称与场次/轮次
        vs: "", // 比赛对阵
        location: "", // 比赛城市与场地
        weather: "", // 天气情况
      },
      canNext: false,
      completeRules: {
        kickTime: [requiredItem("比赛时间")],
        competition: [requiredItem("比赛名称")],
        vs: [requiredItem("比赛对阵")],
        location: [requiredItem("比赛城市与场地")],
        weather: [requiredItem("天气情况")],
      },
    };
  },

  computed: {
    scoutName() {
      const { scoutName } = this.$route.query;
      return scoutName;
    },
    scoutId() {
      const { scoutId } = this.$route.query;
      const localScoutId = yioksStorage.getItem('scoutId');
      return scoutId || localScoutId;
    },

    /* 编辑页 */
    competitionId() {
      const { competitionId } = this.$route.query;
      return competitionId;
    },
    isEdit() {
      const { isEdit } = this.$route.query;
      return 1 === Number(isEdit);
    },
    reportId() {
      const { reportId } = this.$route.query;
      return Number(reportId);
    },
  },

  components: {
    "page-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
  },

  mounted() {
    this.loadPageCompetionsList();
  },

  methods: {
    // 后退方法
    goBack() {
      this.$router.push({
        path: "list",
        query: {
          ...this.$route.query,
          scoutName: this.scoutName || "",
          scoutId: this.scoutId,
        },
      });
    },
    handleLeave(status, flag) {
      if (flag) {
        this.$router.push({
          path: "list",
        });
      }
      this.isShowLeave = false;
    },

    // 填充表单信息
    setFormData(row) {
      if (row) {
        let { kickTime, competition, vs, location, weather } = row;
        if (vs) vs = JSON.parse(vs).join(" vs ");
        this.completeForm = Object.assign({}, this.completeForm, {
          kickTime,
          competition,
          vs,
          location,
          weather,
        });
        this.canNext = true; // 比赛信息已获取，且正已填充表单，允许进行下一步操作
      } else {
        this.canNext = false;
        console.error("比赛信息错误");
      }
    },

    // 点击 下一步
    handleClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.canNext) {
            const { id } = JSON.parse(this.competionChosed);

            let routeQuery = {
              competionId: id,
              scoutId: this.scoutId,
              scoutName: this.scoutName,
            };
            if (this.isEdit) {
              routeQuery["isEdit"] = 1;
              routeQuery["competitionId"] = this.competitionId;
              routeQuery["reportId"] = this.reportId;
            }
            this.$router.push({
              path: "scout_info",
              query: routeQuery,
            });
          } else {
            console.warn("请选择比赛");
            this.$message.warning("请选择比赛");
          }
        }
      });
    },

    // 暂时保存
    tempSave() {
      if (this.canNext) {
        const { id } = JSON.parse(this.competionChosed);

        let routeQuery = {
          competionId: id,
          scoutId: this.scoutId,
          scoutName: this.scoutName,
        };
        if (this.isEdit) {
          routeQuery["isEdit"] = 1;
          routeQuery["competitionId"] = this.competitionId;
          routeQuery["reportId"] = this.reportId;
        }
        this.$router.push({
          path: "list",
          query: routeQuery,
        });
      } else {
        console.warn("请选择比赛");
        this.$message.warning("请选择比赛");
      }
    },

    // 获取比赛表单
    loadPageCompetionsList() {
      getCompetionList()
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.competionsList = data.result.map((item) => {
            const { competition, id } = item;
            const obj = {
              value: id,
              key: competition,
              content: JSON.stringify(item),
            };
            return obj;
          });

          /* 编辑模式 */
          if (this.isEdit) {
            let editRow = null;
            data.result.some((item) => {
              if (Number(this.competitionId) === item.id) {
                editRow = item;
                return;
              }
            });
            if (editRow) {
              this.competionChosed = JSON.stringify(editRow);
              this.setFormData(editRow);
            }
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 用户选择比赛
    handleCompetionChanged(val) {
      let row = null;
      if (val) row = JSON.parse(val);
      this.setFormData(row);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.score-nav
  font-size $font_size_big
  display flex
  align-items center
  line-height $font_size_big
  color $color_white
.page-main
  width 100%
  padding 10px 25px 25px
  box-sizing border-box
  background-color $block_bg_color_base
.scroll-area
  height 500px
  .form-dom
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding-top 20px
    // height 400px
    box-sizing border-box
  .yioks-form-item
    margin-right 180px
  .yioks-input
    width 300px
.btn-box
  width 100%
  display flex
  justify-content center
  align-items center
.mr-25
  margin-right 25px
</style>

<style lang="stylus">
.step-box
  display flex
  width 100%
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
    width 100%
    padding 13px 4%
.form-dom
  .el-form-item__label
    color #fff !important
    font-size 16px
</style>